<template>
    <div class="upload-percentage">
        <span
            data-test-id="upload-progress"
            :style="`width: ${percentage}%`"
            >&nbsp;</span
        >
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',

    props: ['percentage'],
}
</script>

<style scoped>
.upload-percentage {
    width: 100%;
    margin-top: 10px;
    background: #555;
    border-radius: 50px;
    box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
    overflow: hidden;
}

.upload-percentage span {
    display: block;
    height: 100%;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    background-color: rgb(71, 201, 108);
    box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3), inset 0 -2px 6px rgba(0, 0, 0, 0.4);
    position: relative;
    overflow: hidden;
}
</style>
